
import React, { useState } from "react";

const ConversationsListTags = ({ tags, selectedTagId, onTagClick }) => {
  const [showModal, setShowModal] = useState(false);

  const handleTagClick = (tagId) => {
    onTagClick(tagId);
    setShowModal(false);
  };

  // ¿La etiqueta seleccionada actualmente es una de las dinámicas?
  const selectedDynamicTag = tags.find((tag) => tag.id === selectedTagId);

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Etiquetas de la conversación</h3>
      <ul style={styles.tagList}>
        {/* Botón para quitar el filtro y mostrar TODAS */}
        <li
          style={{
            ...styles.tagItem,
            backgroundColor: selectedTagId === null ? "#a80000" : "#e9edef",
            color: selectedTagId === null ? "#fff" : "#54656f",
            opacity: selectedTagId === null ? 1 : 1,
          }}
          onClick={() => onTagClick(null)}
        >
          Todas
        </li>

        {/* Botón para filtrar por "Desde Anuncios" */}
        <li
          style={{
            ...styles.tagItem,
            backgroundColor:
              selectedTagId === "from_ad" ? "#a80000" : "#e9edef",
            color: selectedTagId === "from_ad" ? "#fff" : "#54656f",
            opacity: selectedTagId === "from_ad" ? 1 : 1,
          }}
          onClick={() => onTagClick("from_ad")}
        >
          Desde Anuncios
        </li>

        {/* Botón para filtrar por "No Leídas" */}
        <li
          style={{
            ...styles.tagItem,
            backgroundColor: selectedTagId === "unread" ? "#a80000" : "#e9edef",
            color: selectedTagId === "unread" ? "#fff" : "#54656f",
            opacity: selectedTagId === "unread" ? 1 : 0.7,
          }}
          onClick={() => onTagClick("unread")}
        >
          No Leídas
        </li>

        {/* Botón para filtrar por "IA" */}
        <li
          style={{
            ...styles.tagItem,
            backgroundColor: selectedTagId === "ia" ? "#a80000" : "#e9edef",
            color: selectedTagId === "ia" ? "#fff" : "#54656f",
            opacity: selectedTagId === "ia" ? 1 : 0.7,
          }}
          onClick={() => onTagClick("ia")}
        >
          IA
        </li>

        {/* Botón para filtrar por "Humano" */}
        <li
          style={{
            ...styles.tagItem,
            backgroundColor: selectedTagId === "human" ? "#a80000" : "#e9edef",
            color: selectedTagId === "human" ? "#fff" : "#54656f",
            opacity: selectedTagId === "human" ? 1 : 0.7,
          }}
          onClick={() => onTagClick("human")}
        >
          Humano
        </li>

        {/* Botón que abre el modal con las etiquetas dinámicas */}
        <li
          style={{
            ...styles.tagItem,
            ...styles.tagsButton,
            backgroundColor: selectedDynamicTag ? "#b1f4d1" : "#b1f4d1",
            color: selectedDynamicTag ? "#000" : "#54656f",
            boxShadow: selectedDynamicTag ? "0 0 0 2px #007bff" : "none",
          }}
          onClick={() => setShowModal(true)}
        >
          {selectedDynamicTag ? selectedDynamicTag.name : "Etiquetas"}
        </li>
      </ul>

      {/* Modal con la lista de etiquetas dinámicas */}
      {showModal && (
        <div style={styles.overlay} onClick={() => setShowModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Etiquetas</h3>
              <button
                style={styles.closeButton}
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>

            <ul style={styles.modalTagList}>
              {tags.map((tag) => (
                <li
                  key={tag.id}
                  style={{
                    ...styles.tagItem,
                    opacity: 1,
                    color: selectedTagId === tag.id ? "#000" : "#fff",
                    backgroundColor:
                      selectedTagId === tag.id ? "white" : tag.color,
                    boxShadow:
                      selectedTagId === tag.id
                        ? "0 0 0 2px #007bff"
                        : "none",
                  }}
                  onClick={() => handleTagClick(tag.id)}
                >
                  {tag.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  title: {
    marginBottom: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    borderBottom: "2px solid #ccc",
    paddingBottom: "5px",
  },
  tagList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  tagItem: {
    padding: "2px 6px",
    borderRadius: "16px",
    fontSize: "12px",
    textTransform: "capitalize",
    display: "inline-block",
    cursor: "pointer",
    marginRight: "3px",
    marginBottom: "3px",
    transition: "opacity 0.2s ease",
  },
  tagsButton: {
    fontWeight: "bold",
    border: "1px dashed #54656f",
    backgroundColor: "#06abfd",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "16px",
    width: "320px",
    maxHeight: "70vh",
    overflowY: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
    borderBottom: "1px solid #eee",
    paddingBottom: "8px",
  },
  modalTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "bold",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "16px",
    cursor: "pointer",
    color: "#54656f",
  },
  modalTagList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
};

export default ConversationsListTags;
